import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// Backend timestamps arrive as UTC. Render them in Eastern Time so "4 days ago",
// upload times, audit times, etc. read consistently regardless of the viewer's
// browser zone. Use this for any value that carries a time-of-day; use
// formatDate (UTC, no shift) for calendar-date-only values.
const EASTERN = "America/New_York";

const PATTERNS = {
  datetime: "MMM D, YYYY h:mm A",
  date: "MMM D, YYYY",
  time: "h:mm A",
};

// Append a 'Z' when the backend omitted the zone designator so the instant is
// parsed as UTC rather than browser-local.
export const normalizeUtcIso = (value) => {
  if (typeof value === "string" && !/(Z|[+-]\d{2}:?\d{2})$/.test(value.trim())) {
    return `${value.trim()}Z`;
  }
  return value;
};

const formatDateTime = (isoString, formatKey = "datetime", returnValue = "—") => {
  if (!isoString) return returnValue;
  const d = dayjs(normalizeUtcIso(isoString));
  if (!d.isValid()) return returnValue;
  const pattern = PATTERNS[formatKey] || formatKey; // allow a custom dayjs pattern
  return d.tz(EASTERN).format(pattern);
};

export default formatDateTime;
